import type { BackendRouteDefinition } from '../types';

export const getApiVersionRoute = {
  transport: 'api',
  method: 'GET',
  path: '/version',
} as const satisfies BackendRouteDefinition;
